import { getRequestConfig } from '../auth/auth'
import { ApiGateway } from '../config/config'
import axios from 'axios'
import { fetchWithCallbacks } from '../utils/inflightCallbacks'

export const searchAttributeDefinitions = async (search = {}, cb) => {
  const requestConfig = await getRequestConfig()
  const basePath = `${ApiGateway.attribute}/definitions/search`
  const key = basePath + '::' + JSON.stringify(search || {})

  const requestFn = async () => {
    const response = await axios.post(basePath, search, requestConfig)
    return response.data
  }

  return fetchWithCallbacks(key, requestFn, cb)
}

export default { searchAttributeDefinitions }
